import React, { useMemo } from "react";

import globalStyleFactory from "@/app/global-styles.mjs";
import { internalContainerClass } from "@/util/constants.mjs";
import { useClientLayoutEffect } from "@/util/use-client-layout-effect.mjs";

let globalInjected = false;

/**
 * This is basically a little utility component that ensures that
 * global styles are only injected exactly once in a browser.
 */
export default function GlobalStyleInjector() {
  const GlobalStyles = useMemo(() => {
    return globalStyleFactory(internalContainerClass);
  }, []) as React.FC; // this is the prescribed way to use goober's createGlobalStyles

  // Taking advantage of the fact that layout effects do not run in Node.
  useClientLayoutEffect(() => {
    globalInjected = true;
  }, []);

  return globalInjected ? null : <GlobalStyles />;
}
